module.exports = __webpack_public_path__ + "static/Abacus Zeiterfassung Timeline-b01210bb48e0049773a9cb6cf0610eaa.png";